import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Syncfusion CSS
import '@syncfusion/ej2-base/styles/material-dark.css';
import '@syncfusion/ej2-buttons/styles/material-dark.css';
import '@syncfusion/ej2-inputs/styles/material-dark.css';
import '@syncfusion/ej2-dropdowns/styles/material-dark.css';
import '@syncfusion/ej2-popups/styles/material-dark.css';
import '@syncfusion/ej2-navigations/styles/material-dark.css';
import '@syncfusion/ej2-grids/styles/material-dark.css';
import '@syncfusion/ej2-schedule/styles/material-dark.css';
import '@syncfusion/ej2-richtexteditor/styles/material-dark.css';
import '@syncfusion/ej2-lists/styles/material-dark.css';
import '@syncfusion/ej2-splitbuttons/styles/material-dark.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
